import { IClassroomResource } from "../../classrooms";
import { EntityTypes } from "../../EntityTypes";
import { IMediaResource } from "../../media";
import { ITagResource } from "../../tags";
import { IHydraResource, ITimestampable } from "../../types";
import { IUserResource } from "../../users";

export interface IResourceResource extends IHydraResource, ITimestampable {
    "@type": EntityTypes.RESOURCE;
    title: string;
    description: string;
    url: string;
    classroom: IClassroomResource;
    image?: IMediaResource;
    tags: ITagResource[];
    createdBy: IUserResource;
}

export function isResourceResource(resource: IHydraResource): resource is IResourceResource {
    return resource["@type"] === EntityTypes.RESOURCE;
}
